import { ThemeProvider as MUIThemeProvider } from "@mui/material/styles";

import { eroadTheme } from "../theme/eroadTheme";
import type { AntdThemeProviderProps, ThemeProviderProps } from "../theme/types";
import { ConfigProvider as AntdConfigProvider } from "./ConfigProvider";

const AntdThemeProvider = ({ children }: AntdThemeProviderProps): JSX.Element => (
  <AntdConfigProvider
    theme={{
      hashed: false,
      token: {
        fontFamily: eroadTheme.typography.fonts.primary + ", sans-serif",
        fontWeightStrong: eroadTheme.typography.weights.medium,
        colorPrimary: eroadTheme.colors.primaryBlueDefault,
        colorSuccess: eroadTheme.colors.onsurfaceSuccessGreen,
        colorError: eroadTheme.colors.onsurfaceCriticalRed,
        colorHighlight: eroadTheme.colors.onsurfaceCriticalRed,
        colorWarning: eroadTheme.colors.ragAmber,
        colorTextHeading: eroadTheme.colors.onsurfaceFont,
        colorText: eroadTheme.colors.onsurfaceFont,
        colorLinkHover: eroadTheme.colors.primaryBlueDefault,
        colorLinkActive: eroadTheme.colors.primaryBlueDefault,
        colorBorder: eroadTheme.colors.onsurfaceGrayBorders,
        colorLink: eroadTheme.colors.primaryBlueDefault,
        borderRadius: eroadTheme.shape.borderRadius,
        borderRadiusSM: eroadTheme.shape.borderRadius,
      },
      components: {
        Radio: {
          colorPrimaryHover: eroadTheme.colors.primaryBlueHover,
          colorPrimaryActive: eroadTheme.colors.primaryBlueActive,
        },
        Avatar: {
          colorTextLightSolid: eroadTheme.colors.primaryBlueDefault,
        },
      },
    }}
  >
    {children}
  </AntdConfigProvider>
);

const ThemeProvider = ({ children, theme }: ThemeProviderProps): JSX.Element => (
  <MUIThemeProvider theme={theme}>
    <AntdThemeProvider>{children}</AntdThemeProvider>
  </MUIThemeProvider>
);

export { ThemeProvider };
